exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-select .el-input[data-v-fb3ab7c6]{width:130px}.el-input-group__prepend .el-select[data-v-fb3ab7c6]{width:100px}\n", ""]);

// exports
